<template>
  <div>
    <template v-if="isDetail">
      <b-taglist attached>
        <b-tag type="is-dark" size="is-medium">Dokumententyp</b-tag>
        <b-tag v-if="docType" :type="`is-${matchedDocType} is-medium`">
          {{ docType }}
        </b-tag>
        <b-tag v-else-if="isError" type="is-danger is-medium">
          FEHLER
        </b-tag>
        <b-tag v-else type="is-warning is-medium">
          Wird bearbeitet...
        </b-tag>
      </b-taglist>
    </template>
    <template v-else>
      <b-tag v-if="docType" :type="`is-${matchedDocType}`" rounded>
        {{ docType }}
      </b-tag>
      <b-tag v-else-if="isError" type="is-danger" rounded>
        ERROR
      </b-tag>
      <b-tag v-else type="is-warning" rounded>
        Wird bearbeitet...
      </b-tag>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    docType: { type: String, required: false, default: null },
    isDetail: { type: Boolean, required: false, default: false },
    isError: { type: Boolean, required: false, default: false }
  },
  computed: {
    matchedDocType() {
      return (
        {
          datenblatt: "datenblatt",
          plan: "plan",
          anleitung: "anleitung",
          konformitätserklärung: "konformitaetserklaerung",
          protokoll: "protokoll",
          nachweis: "nachweis",
          konzept: "konzept",
          schema: "schema"
        }[this.docType.toLowerCase()] || "info"
      );
    }
  }
};
</script>

<style></style>
